module.exports = __webpack_public_path__ + "img/play-button-arrow.4a02d2eb.png";